import { render, staticRenderFns } from "./mnclDetail.vue?vue&type=template&id=3a1565b2&scoped=true&"
import script from "./mnclDetail.vue?vue&type=script&lang=js&"
export * from "./mnclDetail.vue?vue&type=script&lang=js&"
import style0 from "./mnclDetail.vue?vue&type=style&index=0&id=3a1565b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1565b2",
  null
  
)

export default component.exports